import Vue from 'vue';
import { ElementApiModule } from 'clockvine-vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    projects: new ElementApiModule('/projects.json'),
    companies: new ElementApiModule('/companies.json'),
    markets: new ElementApiModule('/markets.json'),
    newsCategories: new ElementApiModule('/news-categories.json'),
    newsItems: new ElementApiModule('/news.json'),
    communityCategories: new ElementApiModule('/community-categories.json'),
    communities: new ElementApiModule('/communities.json'),
    careerCategories: new ElementApiModule('/career-categories.json'),
    careerLocations: new ElementApiModule('/career-locations.json'),
    careers: new ElementApiModule('/careers.json'),
  },
});
